import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import { ReactComponent as ProcessDocumentUploadIcon } from '../../../assets/images/process-document-upload-icon.svg'

import './ProcessDocumentFileInput.scss'

const _SUPPORTED_MIME_TYPES = ['image/png', 'image/jpeg', 'application/pdf']

interface ProcessDocumentFileInputProps {
  onFileSelected: (file: File) => Promise<void>
}

export const ProcessDocumentFileInput: React.FC<ProcessDocumentFileInputProps> = ({ onFileSelected }) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const [isHovering, setIsHovering] = useState<boolean>(false)

  useEffect(() => {
    const handleDrop = (e: DragEvent) => {
      e.preventDefault()
    }

    const handleDragOver = (e: DragEvent) => {
      e.preventDefault()
    }

    window.addEventListener('drop', handleDrop)
    window.addEventListener('dragover', handleDragOver)

    return () => {
      window.removeEventListener('drop', handleDrop)
      window.removeEventListener('dragover', handleDragOver)
    }
  }, [])

  const handleFileInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()

    const { files } = e.target
    if (!files?.length) {
      return
    }

    await onFileSelected(files[0])
  }

  const handleDrop = async (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault()
    e.stopPropagation()

    setIsHovering(false)
    const { dataTransfer } = e
    const { files } = dataTransfer
    if (!files.length) {
      return
    }

    const file = files[0]

    if (!_SUPPORTED_MIME_TYPES.includes(file.type)) {
      return
    }

    await onFileSelected(files[0])
  }

  const handleDragEnter = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsHovering(true)
  }

  const handleDragLeave = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsHovering(false)
  }

  const handleDragOver = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <>
      <input
        id='process-document-file-input'
        ref={inputRef}
        type='file'
        accept={_SUPPORTED_MIME_TYPES.join(',')}
        onChange={handleFileInputChange}
        hidden={true}
      />
      <label
        htmlFor='process-document-file-input'
        className={classNames(
          'd-flex flex-column align-items-center justify-content-center zocks-gap-1 zocks-py-3.0 rounded-3 zocks-border-dashed zocks-bg-color-gray-100 process-document-file-input-label',
          {
            'process-document-file-input-label-hovering': isHovering,
          },
        )}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
      >
        <ProcessDocumentUploadIcon />
        <div className='d-flex flex-column align-items-center zocks-gap-0.25'>
          <span className='paragraph-medium bold zocks-text-gray-900'>Drop your file here or click to browse</span>
          <span className='paragraph-small zocks-text-gray-700'>Supported formats: PDF, PNG, JPG</span>
        </div>
      </label>
    </>
  )
}
